// server/utils/authSession.js

import jwt from "jsonwebtoken";
import { getCookie } from "h3";

const SECRET = process.env.JWT_SECRET;
const TOKEN_NAME = "authSession";


/**
 * Crée un JWT contenant les informations de l'utilisateur et le stocke dans un cookie HttpOnly
 * @param {Object} user Profil utilisateur (id, firstName, lastName, username, email, picture, roles)
 * @param {H3Event} event Événement H3 pour setter le cookie
 */
/*export function createUserSession(user, event) {
  const payload = {
    user_id: user.user_id,
    firstName: user.first_name || "",
    lastName: user.last_name || "",
    username: user.username || "",
    email: user.email,
    picture: user.picture || null,
    roles: Array.isArray(user.roles) ? user.roles : [],
  };
  const token = jwt.sign(payload, SECRET, { expiresIn: "2h" });
  // Remplacer le event.res.setHeader actuel par :
  const maxAgeSeconds = 2 * 60 * 60; // 2 heures
  const expireDate = new Date(Date.now() + maxAgeSeconds * 1000).toUTCString();

  // En dev local, autoriser SameSite=Lax pour que le cookie soit bien envoyé sans HTTPS
  const sameSite = process.env.NODE_ENV === "production" ? "None" : "Lax";
  const secureFlag = process.env.NODE_ENV === "production" ? "Secure" : "";

  event.res.setHeader(
    "Set-Cookie",
    [
      `${TOKEN_NAME}=${token}`,
      `Path=/`,
      `HttpOnly`,
      `SameSite=${sameSite}`,
      secureFlag,
      `Expires=${expireDate}`,
      `Max-Age=${maxAgeSeconds}`,
    ]
      .filter(Boolean)
      .join("; ")
  );
}*/
export function createUserSession(user, event) {
  // On prépare le payload du JWT
  const payload = {
    user_id: user.user_id,
    firstName: user.first_name || "",
    lastName: user.last_name || "",
    username: user.username || "",
    email: user.email,
    picture: user.picture || null,
    roles: Array.isArray(user.roles) ? user.roles : [],
  };

  // Génère le token JWT, valide 2 heures
  const token = jwt.sign(payload, SECRET, { expiresIn: "2h" });

  // Durée de vie du cookie en secondes (2 heures)
  const maxAgeSeconds = 2 * 60 * 60;

  // Calcul de la date d'expiration en UTC
  const expireDate = new Date(Date.now() + maxAgeSeconds * 1000).toUTCString();

  // Environnement de production ? (NODE_ENV==="production")
  //   - mêmeSite="None" et "Secure" en prod (nécessite HTTPS),
  //   - mêmeSite="Lax" et pas de Secure en dev local (HTTP)
  const isProd = process.env.NODE_ENV === "production";
  const sameSite = isProd ? "None" : "Lax";
  const secureFlag = isProd ? "Secure" : "";

  // Construit le header Set-Cookie
  // Note : si front et API sont sur sous-domaines différents en prod, ajouter `Domain=longoka.com` ici
  const cookieParts = [
    `${TOKEN_NAME}=${token}`,
    `Path=/`,
    `HttpOnly`,
    `SameSite=${sameSite}`,
    secureFlag,
    `Expires=${expireDate}`,
    `Max-Age=${maxAgeSeconds}`,
    // `Domain=longoka.com`, // Décommentez en PROD si nécessaire pour partager le cookie sur plusieurs sous-domaines
  ].filter(Boolean); // retire les chaînes vides (utile pour secureFlag en dev)

  event.res.setHeader("Set-Cookie", cookieParts.join("; "));
}
/**
 * Récupère le profil utilisateur depuis le cookie JWT
 * @param {H3Event} event Événement H3 contenant les headers
 * @returns {Object|null} Objet profil ou null si non authentifié
 */
export async function getUserFromSession(event) {
  const token = getCookie(event, TOKEN_NAME);
  if (!token) return null;
  //console.log(">>> getUserFromSession – token reçu :", token);
  /*console.log(
    
    ">>> getUserFromSession – token reçu :",
    token,
    "| URL appelée :",
    event.node.req.url
  );*/
  try {
    const decoded = jwt.verify(token, SECRET);
    return {
      user_id: decoded.user_id,
      firstName: decoded.firstName,
      lastName: decoded.lastName,
      username: decoded.username,
      email: decoded.email,
      picture: decoded.picture || null,
      roles: Array.isArray(decoded.roles) ? decoded.roles : [],
    };
  } catch (err) {
    console.error("JWT verification failed:", err);
    return null;
  }
}
